  import React from 'react';

  import { Box, Typography, Button } from '@mui/material';

  import BannerImg from '../assets/images/banner.png'


  const HeroBanner = () => {
    return (
      <Box sx={{ 
          mt: { lg: '212px', xs: '70px' },
          ml: { sm: '50px' }
          }} position="relative" p='20px'>
          <Typography color='#ff2625' fontWeight='600' fontSize='26px' > 
              Fitness Club
          </Typography>
          <Typography fontWeight='700' sx={{ fontSize: { lg: '44px', xs: '40px' } }} mb='23px' mt='30px'>
              Sweat, Smile <br /> and Repeat
          </Typography>
          <Typography fontSize='22px' fontFamily="Alegreya" lineHeight='35px' mb={3}>
              Check out the most effective exercises 
          </Typography>
          <Button variant='contained' href='#exercises' sx={{ backgroundColor: '#ff2625', padding: '10px', '&:hover' : {
            backgroundColor: '#ff5252',
            boxShadow: 'none', 
          } }}>Explore Exercises</Button>
          <Typography fontWeight='600' color='#ff2625' marginTop={'50px'} lineHeight='1' position={'relative'} zIndex={99} fontSize='200px' sx={{ opacity: 0.5, display: { lg: 'block', xs: 'none' }, textShadow: '20px -12px 3px rgba(0, 0, 0, 0.2)', }}>Exercise</Typography>
          <img src={BannerImg} alt='home banner' className='home_banner_img' />
      </Box>
    )
  }

  export default HeroBanner